<template>
  <div class="member-benefits-page">
    <div class="page-header">
      <div class="page-title">会员权益</div>
    </div>
    <picture>
      <img class="img" src="https://assetsprod.onitsukatiger.com/assets/wechat/usergw/user.png" alt="" />
    </picture>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgUrl: "", // TODO: 接口
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.member-benefits-page {
  .page-header {
    box-sizing: border-box;
    width: 100%;
    margin-bottom: 20px;
    padding: 10px 0;

    .page-title {
      font-size: 20px;
      color: #000000;
      line-height: 1;
      text-align: center;
    }
  }

  picture {
    img {
      height: 30vh;
      margin: auto;
      object-fit: cover;
    }
  }
}


@media only screen and (max-width: 1024px) {
  .page-header {
    .page-title {
      font-size: 18px;
    }
  }
}
</style>
